import { NextSeo } from 'next-seo'
import { studentProjectPage } from '@lib/seo'
import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
import BookFreeClassFooterBanner from '@components/home/book-free-class-footer-banner'
import Projects from '@components/student-coding-projects/projects'
import FirstFold from '@components/student-coding-projects/first-fold'

const StudentProjects = () => (
  <>
    <NextSeo {...studentProjectPage} />
    <NavBar isSticky />
    <FirstFold />
    <div style={{ backgroundColor: '#FBFBFB' }}>
      <Projects />
      <BookFreeClassFooterBanner />
    </div>
    <Footer />
  </>
)

export default StudentProjects
